import {del} from 'packages/rest/api';
import * as r from 'runtypes';
import CheckResultRuntime from 'packages/helpers/CheckResultRuntime';

export default async function RemoveProductFromFavorite(product_id: number) {
    const res = await del<true>({
        url: `favorites/products/${product_id}`,
    });
    return CheckResultRuntime(r.Literal(true), res);
}
